<template>
  <div class="statistics-item" v-if="type == 1">
    <div class="statistics-item-title">
      <span>{{ item.label }}</span>
      <el-tooltip
        v-if="item.tips"
        placement="right"
        width="200"
        effect="light"
        trigger="hover"
        :content="item.tips"
      >
        <i class="new-icon-box" style="margin-left: 4px"></i>
      </el-tooltip>
    </div>
    <div class="statistics-item-content">
      {{
        item.prop && item.prop.indexOf("Rate") != -1
          ? (data[item.prop] || 0) + "%"
          : data[item.prop] | numberFormat
      }}
    </div>
  </div>
  <div v-else-if="type == 2">
    <div class="overview-item-title">
      <span>{{ item.label }}</span>
      <el-tooltip
        v-if="item.tips"
        placement="right"
        width="200"
        effect="light"
        trigger="hover"
        :content="item.tips"
      >
        <i class="new-icon-box" style="margin-left: 4px"></i>
      </el-tooltip>
    </div>
    <div class="overview-item-content">
      {{
        item.prop && item.prop.indexOf("Rate") != -1
          ? (data[item.prop] || 0) + "%"
          : data[item.prop] | numberFormat
      }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: Number,
      default: 1,
    },
  },
  filters: {
    numberFormat(value) {
      // 处理null、undefined、空字符串等情况
      if (value === null || value === undefined || value === "") {
        return "0";
      }
      // 转换为数字
      const num = Number(value);

      // 检查是否为有效数字
      if (isNaN(num)) {
        return String(value);
      }
      // 格式化数字，添加千分符
      return num.toLocaleString("zh-CN");
    },
  },
};
</script>

<style scoped lang="scss">
.statistics-item {
  // width: 195px;
  width: calc(12.5% - 12px);
  height: 76px;
  padding: 0 15px;
  margin: 12px 12px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    #f2f6ff 0%,
    rgba(242, 246, 255, 0.15) 100%
  );
  border-radius: 6px 6px 6px 6px;
  border: 1px solid;
  border-image: linear-gradient(
      180deg,
      rgba(227, 232, 255, 1),
      rgba(227, 232, 255, 0)
    )
    1 1;
  .statistics-item-content {
    margin-top: 6px;
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    line-height: normal;
  }
  .statistics-item-title {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
  }
}
.overview-item-content {
  margin-top: 10px;
  font-weight: 500;
  font-size: 18px;
  color: #333333;
  line-height: 1;
  text-align: left;
}
.overview-item-title {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 13px;
  color: #666666;
}
</style>
